import * as React from 'react'

function SvgPublish(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path fill="#2849D6" d="M5 4v2h14V4H5m0 10h4v6h6v-6h4l-7-7-7 7z" />
    </svg>
  )
}

export default SvgPublish
